import {Type} from '@sinclair/typebox'
import {TypeCompiler} from '@sinclair/typebox/compiler'
import {scope, type} from 'arktype'

import {responseData} from '@/lib/api/ResponseData'
import {SupportedCountries} from '@/lib/locale/country'
import {SupportedLocales} from '@/lib/locale/locale'
import type {CartItem} from '@/models/cartModel'
import filteredArray from '@/utils/schema/filteredArray'

const paymentSchema = Type.Object({
  clientSecret: Type.String(),
  order: Type.Object({}), // Check later
  paymentIntentStatus: Type.String(),
})

export const paymentTypeCheck = TypeCompiler.Compile(paymentSchema)
export const StripeAddress = type({
  name: type.string.or(type.null).optional(),
  line1: type.string.or(type.null).optional(),
  line2: type.string.or(type.null).optional(),
  city: 'string > 0',
  state: 'string > 0',
  postalCode: 'string > 0',
  country: SupportedCountries,
})
export type StripeAddress = typeof StripeAddress.infer

export const Tax = type({
  taxAmount: type('string.numeric.parse').or(type.number),
})
export type Tax = typeof Tax.infer

export const TaxResponse = responseData(Tax)
export type TaxResponse = typeof TaxResponse.infer

export type MinimalCartItem = Pick<CartItem, 'id' | 'quantity' | 'price'>

export const ShippingInfo = type({
  name: 'string?',
  phone: 'string?',
  line1: 'string?',
  line2: 'string?',
  city: 'string?',
  state: 'string?',
  postalCode: 'string?',
  country: 'string?',
})
export type ShippingInfo = typeof ShippingInfo.infer
export const BillingInfo = type({
  '...': ShippingInfo,
  'email': 'string?',
})
export type BillingInfo = typeof BillingInfo

export const Addresses = type({
  billingInfo: BillingInfo.optional(),
  shippingInfos: filteredArray(ShippingInfo).optional(),
})
export type Addresses = typeof Addresses.infer

export const AddressesResponse = responseData(Addresses)
export type AddressesResponse = typeof AddressesResponse.infer

export enum PromotionCodeStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum PromotionCodeType {
  AMOUNT_OFF = 'AMOUNT_OFF',
}

const PromotionCode = type({
  id: 'string?',
  type: type.enumerated(...Object.values(PromotionCodeType)).optional(),
  status: type.enumerated(...Object.values(PromotionCodeStatus)).optional(),
  code: 'string?',
  amount: 'string.numeric.parse',
  expiredAt: 'string.date.iso.parse',
  moreInfo: type({maxRedemptionsPerEmail: 'number?'}).optional(),
  createdAt: 'string.date?',
  updatedAt: 'string.date?',
})

export const PromotionCodeResponse = responseData(PromotionCode)
export type PromotionCodeResponse = typeof PromotionCodeResponse.infer

const walletScope = scope({
  Locale: SupportedLocales,
  Wallet: {
    // id: 'string',
    // status: 'string',
    // balances: {
    //   '[Locale]': type({
    //     availableBalance: type('string.numeric').pipe.try(value => Big(value)),
    //     frozenBalance: type('string.numeric').pipe.try(value => Big(value)),
    //   }),
    // },
    moreInfo: {
      // paymentCustomerId: 'string',
      roundUp: 'boolean?',
    },
    // createdAt: 'string.date.iso.parse',
    // updatedAt: 'string.date.iso.parse',
    // version: 'number',
    // balance: {
    //   availableBalance: type('string.numeric').pipe.try(value => Big(value)),
    //   frozenBalance: type('string.numeric').pipe.try(value => Big(value)),
    // },
  },
}).export()

export const Wallet = walletScope.Wallet
export type Wallet = typeof Wallet.infer
export const WalletResponse = responseData(Wallet)
